import { doPrivatePostRequest, doPrivateGetRequest } from "./requests"

export const createUser = (_user, _token) => {
    const path = '/users/create'
    return doPrivatePostRequest(_user, path, _token)
}

export const getUserMembers = (_token) => {
    const path = '/users/get/members'
    const params = {

    }
    return doPrivatePostRequest(params, path, _token)
}

export const updateUser = (_user, _token) => {
    const path = '/users/update'
    return doPrivatePostRequest(_user, path, _token)
}

export const getUsers = (_payload, _token) => {
    const path = '/users/get'
    const payload = {
        'st': _payload?.['st'] ?? null,
        'sk': _payload?.['sk'] ?? null,
        'sv': _payload?.['sv'] ?? null
    };
    return doPrivatePostRequest(payload, path, _token)
}

export const getUserFacilitySummaryUserId = (_user_id, _token) => {
    const path = `/users/get/user/facility/summary/${_user_id}`
    const payload = {};
    return doPrivatePostRequest(payload, path, _token)
}

export const getUserById = (_doc_id, _token) => {
    const path = '/users/get'
    const payload = {
        'st': 'DOC-ID',
        'sk': _doc_id,
        'sv': null
    };
    return doPrivatePostRequest(payload, path, _token)
}

export const getMyConnections = (_token) => {
    const path = '/users/get'
    const payload = {
        'st': 'MY-CONNECTIONS',
    };
    return doPrivatePostRequest(payload, path, _token)
}

export const removeMyConnection = (_user_id, _token) => {
    const path = '/users/connections/remove'
    const payload = {
        'connection_id': _user_id,
    };
    return doPrivatePostRequest(payload, path, _token)
}